import { makeStyles, createStyles } from '../../styles';
export default makeStyles((theme) => createStyles({
    thumbnail: {
        marginRight: theme.spacing(1),
        height: 20,
        width: 20,
    },
}));
//# sourceMappingURL=SelectFieldItem.styles.js.map